import React, { type ReactElement } from 'react'
import { Tab } from './Tab'
import type { TabProps } from './types'

export const Header: React.FC<{
  children: ReactElement<TabProps>[]
}> = ({ children }) => {
  return (
    <div className="flex justify-evenly" role="tablist">
      {React.Children.map(children, (child, idx) => {
        if (!React.isValidElement(child) || child.type !== Tab) {
          throw new Error('<Tabs.Header> only accepts <Tabs.Tab> as children')
        }
        return React.cloneElement(child, { index: idx })
      })}
    </div>
  )
}
